
import { APP_CONFIG } from '../constants';
import { BILLING } from '../constants/billing';

export const pricingService = {
    /**
     * Calculates the discount amount based on a coupon code and current total.
     */
    calculateDiscount(couponCode: string | null, total: number): number {
        if (!couponCode) return 0;

        const code = couponCode.trim().toUpperCase();
        
        switch (code) {
            case 'HOLA-ALLTUC':
                // Flat discount, capped at total
                return Math.min(BILLING.COUPONS.WELCOME_MAX_DISCOUNT, total);
            
            case 'CLUB20':
                // 20% Discount
                return Math.floor(total * BILLING.CLUB.CLUB_20_DISCOUNT_RATE);
            
            case 'CLUB10':
                // 10% Discount
                return Math.floor(total * BILLING.CLUB.CLUB_10_DISCOUNT_RATE);
            
            case APP_CONFIG.COUPON_FREE_SHIPPING:
                // Specific logic handled in shipping, monetary discount is 0 here
                return 0;
                
            default:
                return 0;
        }
    },

    isValidCoupon(code: string): boolean {
        // Mock validation - in real app check against DB/Rules
        return ['TUCUMAN2026', 'ENVIOYA', 'CLUB20', 'CLUB10', 'HOLA-ALLTUC', 'ENVIO-GRATIS'].includes(code);
    },

    calculateClubPrice(price: number): number {
        return Math.floor(price * BILLING.CLUB.CLUB_PRICE_MULTIPLIER);
    }
};
